import React from 'react';
import ReactDOM from 'react-dom/client';  // Update the import
import { BrowserRouter as Router } from 'react-router-dom';
import { Provider } from 'react-redux';
import { createStore, applyMiddleware, compose } from 'redux';
import { SnackbarProvider } from 'notistack';
import combineReducers from './Reducers';
import App from './App';
import registerServiceWorker from './registerServiceWorker';
import SocketController from './SocketController';
import thunk from 'redux-thunk';
import i18next from './i18n';
import { I18nextProvider } from 'react-i18next';
import { Slide, ToastContainer } from 'react-toastify';
import "react-toastify/dist/ReactToastify.css";
import { createTheme } from '@mui/material/styles';
import { ThemeProvider } from '@mui/styles';

export const store = createStore(combineReducers, compose(applyMiddleware(...[thunk])));

const rootElement = document.getElementById('root');
const theme = createTheme({
  spacing: 1,
});
const root = ReactDOM.createRoot(rootElement);

root.render(
  <Provider store={store}>
    <I18nextProvider i18n={i18next}>
      <SnackbarProvider
        maxSnack={5}
        anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
        preventDuplicate
      >
        <Router>
          <ThemeProvider theme={theme}>
            <SocketController />
            <App />
          </ThemeProvider>
        </Router>

        <ToastContainer
          position="top-right"
          autoClose={500}
          hideProgressBar={true}
          newestOnTop={false}
          closeOnClick
          rtl={false}
          pauseOnFocusLoss
          draggable
          pauseOnHover
          transition={Slide}
          theme="colored"
        />
      </SnackbarProvider>
    </I18nextProvider>
  </Provider>
);

// Register service worker (this is optional depending on your app's requirements)
registerServiceWorker();
